import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const ImageGallery = ({ title = 'Image Gallery', ...rest }: IconProps) => {
  return (
    <BaseSvg viewBox="0 0 32 32" title={title} {...rest}>
      <g fill="currentColor">
        <path d="M7,1H25a1,1,0,0,1,1,1V4H6V2A1,1,0,0,1,7,1Z" />
        <path
          d="M30,6H2A1,1,0,0,0,1,7V30a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1V7A1,1,0,0,0,30,6ZM6,13.5A2.5,2.5,0,1,1,8.5,16,2.5,2.5,0,0,1,6,13.5ZM26.882,24.472A1,1,0,0,1,26,25H9a1,1,0,0,1-.633-1.774l11-9a1.017,1.017,0,0,1,.781-.215,1,1,0,0,1,.684.434l6,9A1,1,0,0,1,26.882,24.472Z"
          fill="currentColor"
        />
      </g>
    </BaseSvg>
  )
}

ImageGallery.displayName = 'ImageGallery'

export default ImageGallery
